import React, { useState, useEffect, useRef } from "react";
import { EMPLOYEE_LIST } from "../../../Constants/Config";
import { ciUrl } from "../../../Constants/nodeCi";
import axios from "axios";
import SelectDropDown from "../../../reuseableComponents/SelectDropDown";
import InputTextSearch from "../../../reuseableComponents/InputTextSearch";
import { Grid } from "@mui/material";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import SelectDropDownWithCheckBox from "../../../reuseableComponents/SelectDropDownWithCheckBox";

const FilterEmp = ({
  onFilterEmpDataChange,
  searchId,
  setSearchId,
  transactionsList,
  transactionsListSuperadmin,
  selectedInStoreTransactionsList,
  allInStoreTransactionsSelected,
  handleInStoreTransactionsClick,
  InStoreTransactionsList,
  employeeList,
  setemployeeList,
  selectedInStoreEmployeeList,
  allInStoreEmployeeSelected,
  handleInStoreEmployeeClick,
  OffSearchIdData,
  setOffSearchIdData,
}) => {
  // const [selectedEmployee, setSelectedEmployee] = useState("All Employees");
  // const [selectedEmployeeID, setSelectedEmployeeID] = useState("All Employees");
  // const [filteredData, setFilteredData] = useState({ emp_id: "all" });

  const handleSearch = () => {
    // console.log("Search ID:", searchId);
  };
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();
  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;

  // const dropdownContentClass =
  //   Object.values(filteredData.emp_id).length > 2
  //     ? "dropdown-content scrollable"
  //     : "dropdown-content";
  // const lengthOfArray = Object.values(filteredData.emp_id).length;
  // console.log("Length of array:", lengthOfArray);

  // console.log((filteredData.emp_id).lengt)

  // const handleOptionClick = (option, dropdown) => {
  //   // console.log("handleOptionClick", e.target.value);

  //   switch (dropdown) {
  //     case "employee":
  //       if (option === "All Employees") {
  //         // console.log("handleOptionClick ", option);
  //         setSelectedEmployee("All Employees");
  //         setSelectedEmployeeID("All Employees");
  //         setFilteredData({
  //           ...filteredData,
  //           emp_id: "all",
  //           merchant_id: "",
  //           order_env: "",
  //           limit: "",
  //         });
  //       } else {
  //         const emp_id = option.id;
  //         setSelectedEmployee(option.title);
  //         setSelectedEmployeeID(option.id);
  //         setFilteredData({
  //           ...filteredData,
  //           emp_id,
  //           merchant_id: "",
  //           order_env: "",
  //           limit: "",
  //         });
  //       }
  //       break;
  //     default:
  //       break;
  //   }
  // };

  // console.log("employeeList ,", employeeList);
  const [loadingEmpList, setLoadingEmpList] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          ciUrl(EMPLOYEE_LIST),
          {
            merchant_id: merchant_id,
            token_id: userTypeData?.token_id,
            login_type: userTypeData?.login_type,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${userTypeData?.token}`,
            },
          }
        );

        const EmpList = response.data.result;

        const mappedOptions = EmpList.map((empdata) => ({
          id: empdata.id,
          title: !!empdata?.f_name
            ? empdata?.f_name
            : "" + " " + !!empdata?.l_name
              ? empdata?.l_name
              : "",
        }));
        // console.log("setemployeeList",setemployeeList)
        setemployeeList(mappedOptions);
        setLoadingEmpList(false);
      } catch (error) {
        console.error("Error fetching Employee List:", error);
        setLoadingEmpList(false);
      }
    };
    fetchData();
  }, []);

  // useEffect(() => {
  //   onFilterEmpDataChange(selectedEmployeeID, searchId);
  // }, [selectedEmployeeID, searchId]);

  return (
    <>
      <Grid container className="px-2 sm:px-5">
        <Grid item xs={12}>
          <Grid container className="mt-5">
            <Grid item xs={12} className="">
              <InputTextSearch
                // placeholder="Search orders by order ID, last 4 digits on payment card, Customer Name, Order Amount or invoice ID"
                // placeholder="Search orders by order ID, last 4 digits on payment card, or invoice ID"
                placeholder="Search by Order ID, Card Last 4, Name, or Amount."
                value={OffSearchIdData}
                handleChange={setOffSearchIdData}
                handleSearchButton={handleSearch}
              />
            </Grid>
          </Grid>

          {!searchId && (
            <>
              <Grid container className="mt-5 ">
                <Grid item className="mt_card_header q_dashbaord_netsales ">
                  <h1 className="">Filter By </h1>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="">
                <Grid item xs={12} sm={6} md={4}>
                  <label>Employee</label>
                  <SelectDropDownWithCheckBox
                    className="mt-1"
                    options={employeeList}
                    heading={"All Employees"}
                    title="title"
                    label="Employee"
                    onClickHandler={handleInStoreEmployeeClick}
                    selectedOption={selectedInStoreEmployeeList}
                    allOptionSelected={allInStoreEmployeeSelected}
                  />
                  {/* <SelectDropDown
                    sx={{ pt: 0.5 }}
                    heading={"All Employees"}
                    listItem={employeeList}
                    onClickHandler={handleOptionClick}
                    selectedOption={selectedEmployee}
                    dropdownFor={"employee"}
                    title={"title"}
                  /> */}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <label htmlFor="transactionFilter">Payment Type</label>
                  <SelectDropDownWithCheckBox
                    className="mt-1"
                    options={InStoreTransactionsList}
                    heading={"All"}
                    title="title"
                    label="Select payment type"
                    onClickHandler={handleInStoreTransactionsClick}
                    selectedOption={selectedInStoreTransactionsList}
                    allOptionSelected={allInStoreTransactionsSelected}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default FilterEmp;
